/**
 * MEDICLOUD REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EligibleState } from './eligibleState';
import { ExpiringAssessiblesItemsApiModel } from './expiringAssessiblesItemsApiModel';


export interface EmployeeExpiringAssessiblesApiModel { 
    employeeId: number;
    name: string;
    surname: string;
    personalNumber?: string | null;
    employeeEligibleStatus: EligibleState;
    eligibleTo?: string | null;
    expiringAssessibles: Array<ExpiringAssessiblesItemsApiModel>;
}
export namespace EmployeeExpiringAssessiblesApiModel {
}


